import PlaceIcon from '@mui/icons-material/Place';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type Props = {
  imEvent: ImEventDto;
  placeIconColor?: string;
  truncateAddress?: boolean;
  truncateVenueName?: boolean;
};

export const VenueRow: React.FC<Props> = ({
  imEvent: { participationType, address, venueName },
  placeIconColor,
  truncateAddress,
  truncateVenueName
}) => {
  const shouldShowVenue = () => {
    if (participationType === 'online' || participationType === 'both') {
      // オンライン開催の旨を表示する
      return true;
    }
    // 会場情報がある場合のみ表示する
    return !!(address || venueName);
  };
  const addressToDisplay =
    truncateAddress && address && address.length > 30
      ? address.slice(0, 30) + '...'
      : address;
  const venueNameToDisplay =
    truncateVenueName && venueName && venueName.length > 65
      ? venueName.slice(0, 65) + '...'
      : venueName;

  return (
    <>
      {shouldShowVenue() && (
        <TableRow>
          <TableCell>場所</TableCell>
          <TableCell>
            {participationType === 'online' ? (
              <>オンライン</>
            ) : (
              <>
                {address && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PlaceIcon
                      fontSize="small"
                      sx={{ color: placeIconColor ?? 'primary.main' }}
                    />
                    {addressToDisplay}
                  </Box>
                )}
                <Box sx={{ mt: 0.5 }}>
                  {venueNameToDisplay}
                  {participationType === 'both'
                    ? '（オンラインでも開催されます）'
                    : ''}
                </Box>
              </>
            )}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
